import { QuizQuestion } from "../../../common/components/quiz/useQuiz";

export const bizboxUsersQuizQuestions: QuizQuestion[] = [
  {
    id: "bizbox-users-q1",
    prompt: "What does the BizBox Users module allow you to do?",
    options: [
      { id: "a", label: "View client billing information" },
      { id: "b", label: "Manage BizBox users — invite, edit, lock/unlock, and manage access permissions" },
      { id: "c", label: "View facility assignments only" },
      { id: "d", label: "Reset the group's products" },
    ],
    correctOptionId: "b",
    explanation: "The BizBox Users module is your control panel for BizBox user management — from inviting new users to managing their access and account status.",
  },
  {
    id: "bizbox-users-q2",
    prompt: "How do you invite a new BizBox user?",
    options: [
      { id: "a", label: "Click the Filter button" },
      { id: "b", label: "Click the ⋮ menu on an existing user" },
      { id: "c", label: "Click the 'Invite User' button" },
      { id: "d", label: "Use the search bar" },
    ],
    correctOptionId: "c",
    explanation: "The 'Invite User' button opens a dialog that guides you through searching for an existing user or creating a new account.",
  },
  {
    id: "bizbox-users-q3",
    prompt: "When inviting a user who already has an account, what should you do?",
    options: [
      { id: "a", label: "Create a new account for them anyway" },
      { id: "b", label: "Select them from the search results" },
      { id: "c", label: "Cancel and invite someone else" },
      { id: "d", label: "Skip the search and fill in the form manually" },
    ],
    correctOptionId: "b",
    explanation: "If the search returns a match, select the existing user. This links them to your organization without creating a duplicate account.",
  },
  {
    id: "bizbox-users-q4",
    prompt: "How do you search for a specific BizBox user in the list?",
    options: [
      { id: "a", label: "Use the Filter button" },
      { id: "b", label: "Type their name or email in the search bar and press Enter" },
      { id: "c", label: "Scroll through the table" },
      { id: "d", label: "Click the ⋮ menu" },
    ],
    correctOptionId: "b",
    explanation: "The search bar filters the user list by name or email. Press Enter or click the magnifying glass to apply.",
  },
  {
    id: "bizbox-users-q5",
    prompt: "What can you do from the ⋮ menu on a BizBox user row?",
    options: [
      { id: "a", label: "View their product assignments only" },
      { id: "b", label: "Invite additional users" },
      { id: "c", label: "Edit profile, lock/unlock account, manage access, or delete" },
      { id: "d", label: "Export their details to Excel" },
    ],
    correctOptionId: "c",
    explanation: "The ⋮ menu provides full management: editing the profile, locking or unlocking the account, managing access permissions, and removing the user.",
  },
];

export const groupAdminsQuizQuestions: QuizQuestion[] = [
  {
    id: "group-admins-q1",
    prompt: "What does the Group Admins module allow you to do?",
    options: [
      { id: "a", label: "View client billing information" },
      {
        id: "b",
        label:
          "Manage co-group admins — invite, edit, lock/unlock, and manage access permissions",
      },
      { id: "c", label: "View facility assignments only" },
      { id: "d", label: "Reset the group's products" },
    ],
    correctOptionId: "b",
    explanation:
      "The Group Admins module is your control panel for co-admin management — from inviting new co-admins to managing their access and account status.",
  },
  {
    id: "group-admins-q2",
    prompt: "How do you invite a new co-group admin?",
    options: [
      { id: "a", label: "Click the Filter button" },
      { id: "b", label: "Click the ⋮ menu on an existing admin" },
      { id: "c", label: "Click the 'Invite User' button" },
      { id: "d", label: "Use the search bar" },
    ],
    correctOptionId: "c",
    explanation:
      "The 'Invite User' button opens a dialog that guides you through searching for an existing user or creating a new account.",
  },
  {
    id: "group-admins-q3",
    prompt:
      "When inviting a user who already has an account, what should you do?",
    options: [
      { id: "a", label: "Create a new account for them anyway" },
      { id: "b", label: "Select them from the search results" },
      { id: "c", label: "Cancel and invite someone else" },
      { id: "d", label: "Skip the search and fill in the form manually" },
    ],
    correctOptionId: "b",
    explanation:
      "If the search returns a match, select the existing user. This links them to your organization without creating a duplicate account.",
  },
  {
    id: "group-admins-q4",
    prompt: "How do you search for a specific co-group admin in the list?",
    options: [
      { id: "a", label: "Use the Filter button" },
      {
        id: "b",
        label:
          "Type their name or email in the search bar and press Enter",
      },
      { id: "c", label: "Scroll through the table" },
      { id: "d", label: "Click the ⋮ menu" },
    ],
    correctOptionId: "b",
    explanation:
      "The search bar filters the admin list by name or email. Press Enter or click the magnifying glass to apply.",
  },
  {
    id: "group-admins-q5",
    prompt: "What can you do from the ⋮ menu on a co-group admin row?",
    options: [
      { id: "a", label: "View their product assignments only" },
      { id: "b", label: "Invite additional admins" },
      {
        id: "c",
        label:
          "Edit profile, lock/unlock account, manage access, or delete",
      },
      { id: "d", label: "Export their details to Excel" },
    ],
    correctOptionId: "c",
    explanation:
      "The ⋮ menu provides full management: editing the profile, locking or unlocking the account, managing access permissions, and removing the user.",
  },
];
